var map = {
	"./bg.png": 995,
	"./drag_drop.png": 1334,
	"./job_app_form.png": 565,
	"./logo.png": 6061,
	"./poem.png": 2915,
	"./public_private.png": 5321,
	"./suitcase.png": 3467,
	"./thinking.png": 6899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8330;